// extracted by mini-css-extract-plugin
module.exports = {"content":"InfoModal-module__content___2ciRU"};